<!-- Contacts model -->
<div class="modal-header">
    <h5 class="modal-title">Modifier un projet pdc</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-3">
    <div class="text-left">
        <form>
            <!-- Première ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label for="code">Titre</label>
                    <input [(ngModel)]="item.titre_projet" name="code" type="text" class="form-control" id="code">
                </div>
                <div class="form-group col-md-6">
                    <label for="libelle">Description</label>
                    <input [(ngModel)]="item.description_projet" name="libelle" type="text" class="form-control" id="libelle">
                </div>

            </div>

            <!-- Deuxième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label for="poids">Non du bailleur</label>
                    <input [(ngModel)]="item.nom_bailleur" type="text" name="nom_bailleur" class="form-control"
                        id="nom_bailleur">
                </div>
                <div class="form-group col-md-6">
                    <label for="duree">Lien</label>
                    <input [(ngModel)]="item.lien_article" type="text" name="lien" class="form-control" id="lien">
                </div>

            </div>

            <!-- Troisième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label>Photo</label>
                    <input (change)="onFileSelected($event)" name="photo" type="file" class="form-control"
                        placeholder="Photo " />
                </div>

            </div>


            <div class="text-end mt-3">
                <button (click)="close()" type="button" class="btn btn-light ms-1">
                    <i class="pi pi-times" style="color: #212529"></i> Annuler
                </button>&nbsp;
                <button (click)="editPdc()" type="submit" class="btn btn-success">
                    <i class="pi pi-save" style="color: white"></i> Enregistrer
                </button>
            </div>

        </form>
    </div>
</div>